import React, { useEffect, useState } from "react";
import { object, string } from "yup";
import { CompetitionController, PayoutController } from "../../../controllers";
import constant from "../../../utils/constant";
import { MimaToastUtil } from "../../../components";
import { UpdateParticipants } from "../../../pages";

const UpdateParticipantsContainer = ({ closeModal, selectedRows }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCompetitions = async () => {
      await CompetitionController.getCompetitions();
    };
    fetchCompetitions();
  }, []);

  const validationSchema = () => {
    return object({
      stage: string().required("Select Competition stage"),
      competition: string().required("Select Competition"),
    });
  };

  const selectedParticipants = selectedRows.map((x) => x.original._id);

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      stage: values.stage,
      competition: values.competition.key,
      participants: selectedParticipants,
    };

    const { status, errorMessage } =
      await CompetitionController.upgradeParticipants(payload);
    setLoading(false);
    if (status === constant.Success) {
      MimaToastUtil.success({
        message: constant.Success,
      });
      return closeModal();
    }
    MimaToastUtil.error({
      message: errorMessage,
    });

    return closeModal();
  };

  return (
    <UpdateParticipants
      closeModal={closeModal}
      validationSchem={validationSchema}
      loading={loading}
      onSubmit={onSubmit}
    />
  );
};

export default UpdateParticipantsContainer;
